export default [
    {
        value: "ConstrucaoDePlantaPiloto",
        text: "Construcao de planta piloto"
    },
    {
        value: "ConstrucaoDePrototipo",
        text: "Construção de protótipo"
    },
    {
        value: "EstudoDeMercado",
        text: "Estudo de mercado"
    },
    {
        value: "FabricacaoDeCabecaDeSerie",
        text: "Fabricação de cabeça de série"
    },
    {
        value: "FabricacaoDeLotePioneiro",
        text: "Fabricação de lote pioneiro"
    },
    {
        value: "TesteDePlantaPiloto",
        text: "Teste de planta piloto"
    },
    {
        value: "TesteDePrototipo",
        text: "Teste de protótipo"
    },
    {
        value: "Outros",
        text: "Outros"
    }
]